export default __webpack_public_path__ + "static/media/Canucks.3a20c97f.png";